import { useMemo } from "react";
import { _ } from "i18n";
import { toNullableInt } from "libs/utils";
import SelectComponent from "ui-kit/src/SelectComponent/SelectComponent";
import type { DiscoverGamesClubMetadataOption, GameRow } from "../types";
import {
	clubMetadataSideIsPresent,
	discoverGameRowId,
	parseClubMetadataSide,
	renderClubMetadataUser,
} from "../rowHelpers";

/** Per-game user column (`GameMetadata.countryManager` / contentManager / assignee). */
export function DiscoverGamesGameUserDropdownCell({
	row,
	displayName,
	userId,
	options,
	isUpdating = false,
	onChange,
	readOnlyTitle,
}: {
	row: GameRow;
	displayName: unknown;
	userId: unknown;
	options: DiscoverGamesClubMetadataOption[];
	isUpdating?: boolean;
	onChange?: (gameId: number, userId: number | null) => void;
	readOnlyTitle?: string;
}) {
	const parsed = parseClubMetadataSide(displayName, userId);
	const selectedValue = parsed.idNum !== null ? String(parsed.idNum) : "";
	const gameId = discoverGameRowId(row);
	const mappedOptions = useMemo(
		() =>
			options.map((item) => ({
				value: String(item.value),
				label: item.label,
			})),
		[options],
	);

	if (!onChange || gameId === null || options.length === 0) {
		const content = clubMetadataSideIsPresent(parsed) ? renderClubMetadataUser(parsed) : "-";
		return (
			<div className="thinCell discoverGamesTableV3-clubMetadataManagerCell" title={readOnlyTitle}>
				{content}
			</div>
		);
	}

	return (
		<div className="thinCell discoverGamesTableV3-clubMetadataManagerCell">
			<SelectComponent
				placeholder={_("discover.gamesTable.cellValue.none")}
				value={mappedOptions.find((item) => item.value === selectedValue) ?? null}
				items={mappedOptions}
				isCleareable
				isDisabled={isUpdating}
				menuPortalTarget
				handleChange={(option) => {
					onChange(gameId, toNullableInt(option?.value));
				}}
			/>
		</div>
	);
}
